import { jsx, css } from '@emotion/react';
import { ProgressBar } from 'react-bootstrap';
import { FileUploading } from 'shared/hooks/use-upload-file';
import t from 'react-translate';
import { gray2, gray4, primary } from 'styles/global_defaults/colors';
import { quarterSpacing, threeQuartersSpacing } from 'styles/global_defaults/scaffolding';
import { semiBoldFontWeight, textSmallFontSize } from 'styles/global_defaults/fonts';

export type NvFileUploadProgressProps = {
  id?: string | number;
  hasUploadPercentage: boolean;
  uploadInProgress: boolean;
  fileUploading: FileUploading;
  abortUpload?: (e: any) => void;
  showFileName?: boolean;
  isInlineContent?: boolean;
  className?: string;
};

const NvFileUploadProgress = ({
  id,
  hasUploadPercentage,
  uploadInProgress,
  fileUploading,
  abortUpload,
  showFileName = true,
  isInlineContent = false,
  className,
}: NvFileUploadProgressProps) => {
  const styles = css`
    border: 1px dashed ${gray4};
    box-sizing: content-box;
    padding: ${threeQuartersSpacing}px;

    .file-name {
      color: ${gray2};
      font-weight: ${semiBoldFontWeight};
      margin-top: ${quarterSpacing}px;
      font-size: ${textSmallFontSize}px;
    }

    .cancel {
      color: ${primary};
      cursor: pointer;
      font-size: ${textSmallFontSize}px;
      display: inline-block;
      margin-left: ${quarterSpacing}px;
    }

    .upload-text.inline-content {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .upload-text.inline-content .file-name {
      display: inline;
      margin-top: 0;
    }
  `;

  const now = hasUploadPercentage ? (fileUploading?.uploadPercentage ?? fileUploading?.progress) : 100;
  const uploadLabel = isInlineContent ? t.FILE_UPLOAD.UPLOADING_WITH_ELLIPSIS() : t.FILE_UPLOAD.UPLOADING();

  return (
    <div css={styles} className={className}>
      <ProgressBar animated={!hasUploadPercentage} now={now} />
      {uploadInProgress ? (
        <div className={`upload-text text-center ${isInlineContent ? 'inline-content' : ''}`}>
          <div className='file-name'>{(showFileName && fileUploading?.file?.name) ? fileUploading.file.name : uploadLabel}</div>
          {' '}
          {abortUpload && <div className='cancel' data-qa={id ? `cancel-upload-${id}` : undefined} onClick={abortUpload}>{t.FORM.CANCEL()}</div>}
        </div>
      ) : (
        <div className='upload-text text-center'>
          <div className='file-name'>{t.FORM.SAVING()}</div>
        </div>
      )}
    </div>

  );
};

export default NvFileUploadProgress;
